import { DocumentNode, gql } from '@apollo/client';
import {
  IconProps,
  Tag,
  TagLabel,
  TagLeftIcon,
  TagProps,
} from '@chakra-ui/react';
import * as React from 'react';

import { MembershipStatus } from '@/graphql-types/globalTypes';
import { AwardIcon, UserIcon } from '@/imports/ui/chakra/feather';

import { MembershipStatusTag_MembershipDataFragment } from './graphql-types/MembershipStatusTag_MembershipDataFragment';

export const MembershipStatusTag: React.FC<
  {
    membershipData: MembershipStatusTag_MembershipDataFragment;
    hasSocialInfo?: boolean;
    newView?: boolean;
  } & TagProps
> & { membershipDataFragment: DocumentNode } = ({
  membershipData,
  hasSocialInfo = false,
  newView = false,
  ...tagProps
}) => {
  if (membershipData.membershipStatus === MembershipStatus.NOT_A_MEMBER) {
    return (
      <CustomTag color="yellow.500" bg="yellow.50" hasSocialInfo={hasSocialInfo} newView={newView} leftIcon={UserIcon} {...tagProps}>
        NON-MEMBER
      </CustomTag>
    );
  }

  if (membershipData.membershipStatus === MembershipStatus.LAPSED) {
    return (
      <CustomTag color="red.500" bg="red.50" hasSocialInfo={hasSocialInfo} leftIcon={UserIcon} {...tagProps}>
        EX-MEMBER
      </CustomTag>
    );
  }
  return (
    <CustomTag color="green.500" bg="green.50" borderRadius="full" hasSocialInfo={hasSocialInfo} leftIcon={AwardIcon} {...tagProps}>
      ACTIVE MEMBER
    </CustomTag>
  );
};

const CustomTag: React.FC<
  {
    leftIcon: React.FC<IconProps>;
     hasSocialInfo?: boolean;
     newView?: boolean;
  } & TagProps
> = ({ children, hasSocialInfo = false, newView = false, leftIcon, ...tagProps }) => {
  return (
    <Tag bg="none" fontWeight="bold" {...tagProps} fontSize="xs" display="flex" alignItems="center"justifyContent="center">
      {!hasSocialInfo && newView && <TagLeftIcon as={leftIcon} />}
      <TagLabel fontSize="10px">{children}</TagLabel>
    </Tag>
  );
};

MembershipStatusTag.membershipDataFragment = gql`
  fragment MembershipStatusTag_MembershipDataFragment on MembershipData {
    membershipStatus
    __typename
  }
`;
